import React from 'react';

// Error Boundary for video elements
class VideoErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a video-related error
    if (error.message && (error.message.includes('supported sources') || error.message.includes('video'))) {
      console.warn('Video error caught by boundary:', error.message);
      return { hasError: true };
    }
    return null;
  }

  componentDidCatch(error, errorInfo) {
    // Log video errors silently
    if (error.message && (error.message.includes('supported sources') || error.message.includes('video'))) {
      console.warn('Video loading error suppressed:', error.message);
    }
  }

  render() {
    if (this.state.hasError) {
      // Return a fallback UI for video errors
      return this.props.fallback || <div className="w-full h-full bg-gray-100 rounded-lg flex items-center justify-center text-gray-500">
        <div className="text-center">
          <div className="text-2xl mb-2">🎥</div>
          <div className="text-sm">Video Preview</div>
        </div>
      </div>;
    }

    return this.props.children;
  }
}

export default VideoErrorBoundary;
